import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Wire ApiClient to live Supabase auth state before any component renders.
// Without this call, the first request after a refresh races auth hydration.
import { initApiAuth } from '@shoots/auth'
initApiAuth()

// Import auth test utilities in development
if (import.meta.env.DEV) {
  import('./utils/authTestUtils')
}

// Initialize PostHog
import { posthogService } from './services'
posthogService.initialize()

// Initialize theme (before React mounts, for flash-free load)
import { useThemeStore } from './store/useThemeStore'
import { resolveSystemTheme } from './utils/themeUtils'

function resolveInitialTheme(): string {
  const { theme } = useThemeStore.getState()
  if (theme !== 'system') return theme
  return resolveSystemTheme()
}

document.documentElement.setAttribute('data-theme', resolveInitialTheme())

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
